import type {
    CheckBoxMarkIconConstantType
} from "./type";
import {
    createLucideIcon,
    type LucideIcon
} from "lucide-react-native";

const CHECK_BOX_MARK_ICONS = new Map<number, LucideIcon>();

export const CHECK_BOX_MARK_PATH = "M20 6 9 17l-5-5";

export const getCheckBoxMarkIcon = ({
    strokeWidth
}: CheckBoxMarkIconConstantType): LucideIcon => {
    const cachedIcon = CHECK_BOX_MARK_ICONS.get(strokeWidth);

    if(cachedIcon) {
        return cachedIcon;
    }

    const icon = createLucideIcon("Check", [
        [
            "path",
            {
                strokeWidth: String(strokeWidth),
                d: CHECK_BOX_MARK_PATH,
                key: "mark"
            }
        ]
    ]);

    CHECK_BOX_MARK_ICONS.set(strokeWidth, icon);

    return icon;
};
